import { render, staticRenderFns } from "./BatchesManagerForm.vue?vue&type=template&id=5b40d9de&"
import script from "./BatchesManagerForm.vue?vue&type=script&lang=ts&"
export * from "./BatchesManagerForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports